import TextArea, { TextAreaProps } from 'antd/lib/input/TextArea';
import React from 'react';

import styles from './TextArea.module.css';

interface CustomTextAreaProps extends TextAreaProps {
  label?: string;
  required?: boolean;
}

export const TextAreaAntd: React.ForwardRefExoticComponent<
  CustomTextAreaProps & React.RefAttributes<HTMLTextAreaElement>
> = React.forwardRef(({ label, required = false, ...props }, ref) => (
  <div className={styles.textAreaWrapper}>
    {label && (
      <span className={styles.textAreaLabel}>
        {label}
        {required && ' *'}
      </span>
    )}
    <TextArea {...props} ref={ref} />
  </div>
));

TextAreaAntd.displayName = 'TextAreaAntd';
